import { Button, Select, SelectOption } from "@rio-cloud/rio-uikit";
import { NameInputChange } from "./form";
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { ReactNode } from "react";

interface Props {
    errorMessage?: string;
    label: string;
    options: SelectOption[];
    newOption?: SelectOption;
    onCreateNewOption: (name: NameInputChange) => void
    inputChange: (name: NameInputChange, value?: string) => void;
    value: string;
    name: NameInputChange;
    onRight?: () => void;
    iconRight?: string;
    tooltip?: ReactNode;
    disabled?: boolean;
    disabledRight?: boolean
    useClear?: boolean;
    useFilter?: boolean;
}

const InputSelect = ({
    errorMessage,
    label,
    newOption,
    options,
    inputChange,
    onCreateNewOption,
    value,
    name,
    onRight,
    iconRight,
    disabled,
    disabledRight,
    tooltip,
    useClear,
    useFilter
}: Props) => {
    const renderSelect = () => {
        const inputOptions = newOption ? [...options, newOption] : options;

        return (
            <Select
                id={name}
                disabled={disabled}
                placeholder='Selecione'
                options={inputOptions}
                useClear={useClear}
                useFilter={useFilter}
                onChange={item => {
                    if (item?.id === 'other') {
                        onCreateNewOption(name);
                        return;
                    }
                    inputChange(name, item?.id as string);
                }}
                value={[value]}
                className='rounded-small flex-1-1'
                errorMessage={errorMessage}
            />
        )
    }
    return (
        <div className={`form-group ${errorMessage ? "has-error" : ""}`}>
            {!iconRight ? (
                <>
                    <div className="display-flex justify-content-between align-items-center margin-bottom-5">
                        <label className="margin-0" htmlFor={name}>{label}</label>
                        {tooltip && (
                            <SimpleTooltip placement='bottom-start' content={tooltip}>
                                <span className='rioglyph rioglyph-info-sign text-color-info text-size-18' />
                            </SimpleTooltip>
                        )}
                    </div>
                    {renderSelect()}
                </>
            ) : (
                <>
                    <label htmlFor={name}>{label}</label>
                    <div className='display-flex align-items-center gap-10 width-100pct'>
                        {renderSelect()}
                        <Button
                            disabled={disabledRight}
                            onClick={onRight}
                            iconName={iconRight}
                            iconOnly
                        />
                    </div>
                </>
            )}
        </div>
    )
}

export default InputSelect;